<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-' + item.ID">
                <td>{{ chinaStoreDisplay(item.ChinaStoreID) }}</td>
                <td>{{ storeDisplay(item.ReceivePlaceID) }}</td>
                <td class="text-end">{{ item.WeightFrom | currency('',1) }}</td>
                <td class="text-end">{{ item.WeightTo | currency('',1) }}</td>
                <td class="text-end">{{ item.Amount | currency }}</td>
                <td>{{ (item.ModifiedDate || item.CreatedDate) | display_date }}</td>
                <td>{{ item.ModifiedBy }}</td>
                <td class="text-center">
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)">fa-edit</v-icon>
                  <v-icon medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
  },
  props: ["priceId"],
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      headers: [
        {
          text: "Kho TQ",
          value: "ChinaStoreID",
          filterable: true,
          values: [],
          dataType: dataType["Enum"],
        },
        {
          text: "Kho VN",
          value: "ReceivePlaceID",
          filterable: true,
          values: [],
          dataType: dataType["Enum"],
        },
        {
          text: "Cân nặng (Min)",
          value: "WeightFrom",
          align: "end",
          decimal: 1,
          filterable: true,
          dataType: dataType["Number"],
        },
        {
          text: "Cân nặng (Max)",
          value: "WeightTo",
          align: "end",
          decimal: 1,
          filterable: true,
          dataType: dataType["Number"],
        },
        {
          text: "Tiền Phí",
          value: "Amount",
          align: "end",
          filterable: true,
          dataType: dataType["Number"],
        },
        {
          text: "Ngày sửa",
          value: "ModifiedDate",
          filterable: true,
          dataType: dataType["Date"],
        },
        {
          text: "Người sửa",
          value: "ModifiedBy",
          filterable: true,
          dataType: dataType["String"],
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false,
        },
      ],
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "feeWeight_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [(v) => !!v || "Trường dữ liệu không được để trống."],
    };
  },
  watch: {
    pagination: {
      handler: function (val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true,
    },
    chinaStores() {
        let header_item = _.find(this.headers, {value: "ChinaStoreID"});
        if(header_item) {
            header_item.values = _.map(this.chinaStores, (item) => {
                return {
                    value: item.ID,
                    name: item.Name
                }
            }) || []
        }
    },
    stores() {
        let header_item = _.find(this.headers, {value: "ReceivePlaceID"});
        if(header_item) {
            header_item.values = _.map(this.stores, (item) => {
                return {
                    value: item.ID,
                    name: item.Name
                }
            }) || []
        }
    }
  },
  computed: mapState({
    items: (state) => state.feeWeight.all.data,
    total_rows: (state) => state.feeWeight.all.total,
    loading: (state) => state.feeWeight.loading,
    currentFeeWeight: (state) => state.feeWeight.selected,
    stores: (state) => state.commons.stores,
    chinaStores: (state) => state.commons.chinaStores,
  }),
  methods: {
    filter_data: function () {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions,
      };
      if (this.priceId) {
        param.filter.push({
          column: "PriceID",
          value: this.priceId,
          condition: "equal",
        });
      }
      this.$store.dispatch("feeWeight/getList", param);
    },
    gotoDetail: function (id) {
      if(this.priceId > 0) {
        this.$emit('eventEditRow', id);
        return;
      }
      let routeData = this.$router.resolve({
        name: "FeeWeightDetail",
        params: {
          Pid: id,
          title: `Chi tiết phí cân nặng (#${id})`,
        },
      });
      window.open(routeData.href, "_blank");
    },
    deleteItem: function (id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", {'id': id, 'viewName': this.viewName});
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      this.$router.push({
        name: "FeeWeightDetail",
        params: {
          Pid: "tao-moi",
          title: `Tạo mới phí cân nặng`,
        },
      });
    },
    storeDisplay(value) {
      const store = _.find(this.stores, { ID: value });
      return store ? store.Name : "";
    },
    chinaStoreDisplay(value) {
      const store = _.find(this.chinaStores, { ID: value });
      return store ? store.Name : "";
    },
  },
  mounted() {
    this.$store.dispatch("commons/getAllStores");
    this.$store.dispatch("commons/getAllChinaStores");
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", item => {
      if(item.viewName == this.viewName) {
        this.$store.dispatch("feeWeight/removeDetail", item.id);
      }
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  },
};
</script>
